import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cceb27ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "me-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Module start +", -1))
const _hoisted_5 = { class: "set-date" }
const _hoisted_6 = { class: "border-bottom d-flex align-items-center justify-content-between w-100" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headline" }, "Set Deadline", -1))
const _hoisted_8 = { class: "mt-3 mb-2 d-flex flex-wrap" }
const _hoisted_9 = { class: "dropdown me-1" }
const _hoisted_10 = {
  class: "number-select",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_11 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "dropdown d-flex me-1 mb-1" }
const _hoisted_14 = {
  class: "number-select",
  type: "button",
  id: "dropdownMenuButton2",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_15 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton2"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  class: "number-select ms-1",
  type: "button",
  id: "dropdownMenuButton3",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_18 = {
  class: "dropdown-menu text-start",
  "aria-labelledby": "dropdownMenuButton3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isDeadlineSelected && !_ctx.setDeadlineDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "cursor-pointer pe-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setInitialDeadline && _ctx.setInitialDeadline(...args)))
          }, "Deadline ")
        ]))
      : (_ctx.isDeadlineSelected && !_ctx.setDeadlineDate)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "d-flex align-items-center cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setInitialDeadline && _ctx.setInitialDeadline(...args)))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getSelectedNumber) + " " + _toDisplayString(_ctx.selectedPeriodType), 1)
            ]),
            _createVNode(_component_feather_icon, {
              onClick: _withModifiers(_ctx.resetDeadline, ["stop"]),
              type: "x-circle",
              class: "cursor-pointer",
              size: "15",
              stroke: "#0D0C21"
            }, null, 8, ["onClick"])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["select-period-wrapper d-flex flex-column align-items-center", { 'select-period-wrapper-open': _ctx.setDeadlineDate }])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_feather_icon, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setDeadlineDate = false)),
                type: "x",
                class: "cursor-pointer",
                size: "15",
                stroke: "#0D0C21"
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getSelectedNumber), 1),
                _createElementVNode("ul", _hoisted_11, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(99, (index) => {
                    return _createElementVNode("li", { key: index }, [
                      _createElementVNode("a", {
                        onClick: _withModifiers(($event: any) => (_ctx.setDeadline(index)), ["stop","prevent"]),
                        class: "dropdown-item"
                      }, _toDisplayString(index), 9, _hoisted_12)
                    ])
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.selectedPeriodType), 1),
                _createElementVNode("ul", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodTypes, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.selectedPeriodType = item),
                        class: "dropdown-item"
                      }, _toDisplayString(item), 9, _hoisted_16)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.selectProjectState), 1),
                _createElementVNode("ul", _hoisted_18, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectProjectState = _ctx.projectState.afterModuleActivation, _ctx.setDeadline(_ctx.selectedNumber))),
                      class: "dropdown-item"
                    }, _toDisplayString(_ctx.projectState.afterModuleActivation), 1)
                  ])
                ])
              ])
            ])
          ], 2))
  ]))
}